var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm"},[_c('v-btn',{staticClass:"mr-2",attrs:{"depressed":"","color":"primary"},on:{"click":_vm.confirm}},[_vm._v(" "+_vm._s(_vm.confirmText)+" ")]),_c('v-btn',{attrs:{"depressed":"","color":"secondary"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.rejectText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }